import React, { createContext, useContext, useState, useCallback } from "react";

const BookingContext = createContext(null);

export function BookingProvider({ children }) {
  const [open, setOpen] = useState(false);
  const [preselect, setPreselect] = useState("");

  const openBooking = useCallback((roomName = "") => {
    setPreselect(roomName);
    setOpen(true);
  }, []);

  return (
    <BookingContext.Provider value={{ open, setOpen, preselect, openBooking }}>
      {children}
    </BookingContext.Provider>
  );
}

export function useBooking() {
  const ctx = useContext(BookingContext);
  if (!ctx) throw new Error("useBooking must be used within BookingProvider");
  return ctx;
}
